import dayjs from "dayjs";

const isDay = (value) => /^\d{4}-\d{2}-\d{2}$/.test(value || "") && dayjs(value).isValid();

/**
 * Date range from the "start" and "end" URL parameters (YYYY-MM-DD), set by "View more" on the homepage
 *
 * @param {URLSearchParams} searchParams - Parameters of the dashboard URL
 * @param {string} [todayWindow] - Window of the dashboard endpoint for today, a single other day is "one_day"
 * @returns {{start: dayjs.Dayjs, end: dayjs.Dayjs, window: string|null}|null} First day from midnight, last day until
 *   the end of the day and the window (a single day per hour, longer ranges per day), or null without a valid range
 */
export const getUrlDateRange = (searchParams, todayWindow = "today") => {
  const start = searchParams.get("start");
  const end = searchParams.get("end");
  if (!isDay(start) || !isDay(end) || end < start) return null;

  const startDay = dayjs(start).startOf("day");
  let window = null;
  if (start === end) window = startDay.isSame(dayjs(), "day") ? todayWindow : "one_day";

  return { start: startDay, end: dayjs(end).endOf("day"), window };
};
